// Shared cross-package types for the MUAA Alumni monorepo (consumed by mobile/ and admin/).
//
// The Supabase-generated database types land in ./database.types.ts via:
//   SUPABASE_ACCESS_TOKEN=dummy npx supabase --workdir backend gen types typescript --local \
//     | sed '/^Connecting to db/d' > shared/src/database.types.ts
// Re-run after every schema migration. The `sed` strips a stray CLI progress line
// the generator otherwise leaks onto stdout (which breaks tsc on this file).

export * from './database.types';

// ── Feed post media ───────────────────────────────────────────────────────────
// Typed view of `user_posts.media` (a jsonb array). A post carries an ordered
// list of media so the Activity Feed card can render a single image, a multi-image
// grid, or a video. Mirrored onto the Stream activity `custom.media` for the live
// feed. `parsePostMedia` narrows the raw jsonb tolerantly (drops malformed items).
export interface PostMedia {
  type: 'image' | 'video';
  url: string;
  width?: number;
  height?: number;
  /** Video length in seconds (videos only). */
  duration?: number;
}

export function parsePostMedia(value: unknown): PostMedia[] {
  if (!Array.isArray(value)) return [];
  const out: PostMedia[] = [];
  for (const raw of value) {
    if (!raw || typeof raw !== 'object') continue;
    const m = raw as Record<string, unknown>;
    if (typeof m.url !== 'string') continue;
    const item: PostMedia = { type: m.type === 'video' ? 'video' : 'image', url: m.url };
    if (typeof m.width === 'number') item.width = m.width;
    if (typeof m.height === 'number') item.height = m.height;
    if (typeof m.duration === 'number') item.duration = m.duration;
    out.push(item);
  }
  return out;
}

export * from './devRuntimeConfig';

// ── Announcement targeting ────────────────────────────────────────────────────
// Who an admin's urgent notice is for. Shared rather than duplicated because the
// mobile app evaluates the audience and the admin writes a summary of it; two
// copies would eventually disagree and the admin would be told they are reaching
// an audience they are not.
export * from './announcementAudience';

// ── Jaguar-Owned ────────────────────────────────────────────────────────────
// Nomination-month cutoff + share copy shared between mobile and admin — see
// jaguarOwned.ts's header for why these exist here and not in either app.
export * from './jaguarOwned';
